import React, { useEffect, useState } from 'react';
import { FiFileText, FiUpload, FiSearch, FiUsers, FiSettings, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { RiBarcodeLine } from 'react-icons/ri';

const SidebarMenu = ({ view, setView }) => {
  const [adminOpen, setAdminOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem('sidebar_collapsed') === '1'; } catch (_) { return false; }
  });

  useEffect(() => {
    try { localStorage.setItem('sidebar_collapsed', collapsed ? '1' : '0'); } catch (_) {}
  }, [collapsed]);
  const menuItems = [
    ['barcode', 'New Barcode'],
    ['all', 'All Files'],
    ['search', 'Search PDFs'],
    ['upload', 'Scan / Upload Files'],
    // ['manage', 'Manage Files'], // hidden for now
  ];

  const width = collapsed ? 60 : 220;

  // Keep Admin section open when viewing an Admin page; close it otherwise
  useEffect(() => {
    const isAdminView = String(view || '').startsWith('admin-');
    setAdminOpen(isAdminView);
  }, [view]);

  const renderIcon = (key) => {
    switch (key) {
      case 'barcode': return <RiBarcodeLine size={18} aria-hidden />;
      case 'all': return <FiFileText size={18} aria-hidden />;
      case 'upload': return <FiUpload size={18} aria-hidden />;
      case 'search': return <FiSearch size={18} aria-hidden />;
      default: return null;
    }
  };

  return (
    <div id="menu" style={{
      width,
      backgroundColor: 'var(--sidebar-bg)',
      padding: collapsed ? 8 : 14,
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      whiteSpace: 'nowrap',
      borderRight: '1px solid var(--border)'
    }}>
      {/* Collapse toggle */}
      <div style={{ display: 'flex', justifyContent: collapsed ? 'center' : 'flex-end', marginBottom: 6 }}>
        <button
          onClick={() => setCollapsed(!collapsed)}
          title={collapsed ? 'Expand menu' : 'Collapse menu'}
          className="btn-ghost"
          style={{ padding: collapsed ? '4px 6px' : '4px 8px', lineHeight: 1 }}
        >
          {collapsed ? <FiChevronRight /> : <FiChevronLeft />}
        </button>
      </div>
      {menuItems.map(([key, label]) => (
        <div
          key={key}
          onClick={() => { setView(key); }}
          style={{
            padding: collapsed ? 6 : 8,
            marginBottom: 6,
            cursor: 'pointer',
            backgroundColor: view === key ? 'var(--primary)' : 'var(--card-bg)',
            color: view === key ? 'var(--primary-contrast)' : 'var(--text)',
            borderRadius: 4,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            border: view === key ? '1px solid var(--primary)' : '1px solid var(--border)',
            boxShadow: view === key ? '0 1px 2px rgba(0,0,0,0.1)' : 'none',
            display: 'flex',
            alignItems: 'center',
            gap: collapsed ? 0 : 6,
            justifyContent: collapsed ? 'center' : 'flex-start',
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = view === key ? '#1565c0' : 'var(--hover-bg)'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = view === key ? 'var(--primary)' : 'var(--card-bg)'}
          title={label}
        >
          {renderIcon(key)}
          {!collapsed && <span>{label}</span>}
        </div>
      ))}

      {/* Admin section */}
      {/* Admin section */}
      {(() => {
        const isAdminView = String(view || '').startsWith('admin-');
        const adminHighlighted = adminOpen && !isAdminView; // un-highlight when a submenu is active
        return (
      <div
        onClick={() => !collapsed && setAdminOpen(!adminOpen)}
        style={{
          padding: collapsed ? 8 : 10,
          marginBottom: 6,
          cursor: 'pointer',
          backgroundColor: adminHighlighted ? 'var(--primary)' : 'var(--card-bg)',
          color: adminHighlighted ? 'var(--primary-contrast)' : 'var(--text)',
          borderRadius: 4,
          border: adminHighlighted ? '1px solid var(--primary)' : '1px solid var(--border)',
          userSelect: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'flex-start',
          gap: collapsed ? 0 : 8,
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = adminHighlighted ? '#1565c0' : 'var(--hover-bg)'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = adminHighlighted ? 'var(--primary)' : 'var(--card-bg)'}
        title={collapsed ? 'Admin' : undefined}
      >
        <FiSettings aria-hidden />
        {!collapsed && <span>Admin {adminOpen ? '▾' : '▸'}</span>}
      </div>
        );
      })()}
      {(!collapsed && adminOpen) && (
        <div style={{ marginLeft: 6 }}>
          <div
            onClick={() => { setView('admin-users'); }}
            style={{
              padding: 6,
              marginBottom: 6,
              cursor: 'pointer',
              backgroundColor: view === 'admin-users' ? 'var(--primary)' : 'var(--card-bg)',
              color: view === 'admin-users' ? 'var(--primary-contrast)' : 'var(--text)',
              borderRadius: 4,
              border: view === 'admin-users' ? '1px solid var(--primary)' : '1px solid var(--border)',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = view === 'admin-users' ? '#1565c0' : 'var(--hover-bg)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = view === 'admin-users' ? 'var(--primary)' : 'var(--card-bg)'}
          >
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <FiUsers aria-hidden /> Users
            </span>
          </div>
          <div
            onClick={() => { setView('admin-cabinets'); }}
            style={{
              padding: 6,
              marginBottom: 6,
              cursor: 'pointer',
              backgroundColor: view === 'admin-cabinets' ? 'var(--primary)' : 'var(--card-bg)',
              color: view === 'admin-cabinets' ? 'var(--primary-contrast)' : 'var(--text)',
              borderRadius: 4,
              border: view === 'admin-cabinets' ? '1px solid var(--primary)' : '1px solid var(--border)',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = view === 'admin-cabinets' ? '#1565c0' : 'var(--hover-bg)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = view === 'admin-cabinets' ? 'var(--primary)' : 'var(--card-bg)'}
          >
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <FiSettings aria-hidden /> Cabinets
            </span>
          </div>
          <div
            onClick={() => { setView('admin-status'); }}
            style={{
              padding: 6,
              marginBottom: 6,
              cursor: 'pointer',
              backgroundColor: view === 'admin-status' ? 'var(--primary)' : 'var(--card-bg)',
              color: view === 'admin-status' ? 'var(--primary-contrast)' : 'var(--text)',
              borderRadius: 4,
              border: view === 'admin-status' ? '1px solid var(--primary)' : '1px solid var(--border)',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = view === 'admin-status' ? '#1565c0' : 'var(--hover-bg)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = view === 'admin-status' ? 'var(--primary)' : 'var(--card-bg)'}
          >
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <FiSettings aria-hidden /> Server Status
            </span>
          </div>
        </div>
      )}

      {/* Collapsed quick admin users icon */}
      {collapsed && (
        <div
          onClick={() => { setView('admin-users'); }}
          title="Users"
          style={{
            padding: 6,
            marginTop: 6,
            cursor: 'pointer',
            backgroundColor: view === 'admin-users' ? 'var(--primary)' : 'var(--card-bg)',
            color: view === 'admin-users' ? 'var(--primary-contrast)' : 'var(--text)',
            borderRadius: 4,
            border: view === 'admin-users' ? '1px solid var(--primary)' : '1px solid var(--border)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = view === 'admin-users' ? '#1565c0' : 'var(--hover-bg)'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = view === 'admin-users' ? 'var(--primary)' : 'var(--card-bg)'}
        >
          <FiUsers aria-hidden />
        </div>
      )}
    </div>
  );
};

export default SidebarMenu;
